import ApiService from '@/services/ApiService';
import { trimString } from '@/helpers/StringHelpers';
import { formatAddress, getFullAddressString } from '@/helpers/AddressHelpers';

export default class LegacyFetchAddressesForPostcode {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * LegacyFetchAddressesForPostcode constructor.
     *
     * @todo Check VUE_APP_COUNTRY_ISO to dynamically change the postcode lookup provider for the country. Currently
     * postcode provider is hard coded to GetAddress.io for UK addresses. Alternatively use international postcode
     * lookup provider.
     *
     * @returns {void}
     */
    constructor() {
        let apiServiceParameters = {
            'api-key': process.env.VUE_APP_GET_ADDRESS_API_KEY,
        };

        this.apiService = new ApiService('https://api.getaddress.io/v2/uk/', apiServiceParameters);
    }

    /**
     * Fetch list of available address via API for requested postcode.
     *
     * @param {String} postcode
     *
     * @returns {Array}
     */
    async handle(postcode) {
        let request = await this.apiService
            .get(postcode)
            .catch(() => false);

        return request.status === 200 ? this.createAvailableAddressesList(request.data.Addresses) : [];
    }

    /**
     * Build the available addresses list for multiselect options.
     *
     * @param {Array} addresses
     *
     * @returns {Array}
     */
    createAvailableAddressesList(addresses) {
        return addresses.map((addressString) => {
            let address = formatAddress(addressString);

            // Build full address for the multiselect label.
            let fullAddress = getFullAddressString(address);
            address.fullAddress = trimString(fullAddress, 45, true);

            return address;
        });
    }
}
